import { Link } from "@tanstack/react-router";
import { ArrowUpRight } from "lucide-react";

/** AEO & GEO cards on the About pages; EN and BN pass their own copy and links. */
export function AiSearchCards({
  items,
  intro,
  more,
}: {
  items: ReadonlyArray<{ t: string; d: string; to: string }>;
  intro: string;
  more: string;
}) {
  return (
    <>
      <p className="text-lg text-muted-foreground leading-relaxed max-w-3xl">{intro}</p>
      <div className="mt-10 grid md:grid-cols-3 gap-6">
        {items.map((p) => (
          <Link key={p.t} to={p.to} className="group rounded-2xl border border-border bg-card p-6 hover:border-primary/60 transition-colors">
            <h3 className="font-display text-xl">{p.t}</h3>
            <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{p.d}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm text-primary">{more} <ArrowUpRight size={14} /></span>
          </Link>
        ))}
      </div>
    </>
  );
}
